module.exports = __webpack_public_path__ + "img/directions.e0f129c0.svg";